import React, { useState } from "react";
import Asset from "./asset";
import styles from "./project-single.module.scss";
import theme from "../styles/theme.module.scss";

function Row(props) {
  const template = props.row.splitTemplate;
  const insetPosition = props.row.insetPosition;
  if (template == "fiftyfifty") {
    return (
      <div
        className={[styles.row, styles[props.type], styles[template]].join(" ")}
        style={{ backgroundColor: `${props.bgColor}`, color: `${props.textColor}` }}
      >
        <div className={`${styles.half}`}>
          <Asset asset={props.row.asset[0]} maxWidth="1100" />
        </div>
        <div className={`${styles.half}`}>
          <Asset asset={props.row.asset[1]} maxWidth="1100" />
        </div>
      </div>
    );
  } else if (template == "inset-left") {
    return (
      <div
        className={[
          styles.row,
          styles.insetLeft,
          styles[props.type],
          styles[template],
          theme.gmcont,
        ].join(" ")}
        style={{ backgroundColor: `${props.bgColor}`, color: `${props.textColor}` }}
      >
        <div
          className={[
            theme.gmfull,
            theme.fmcont,
            theme.fmcenter,
            theme.fmvcenter,
            styles.half,
            styles.inset,
          ].join(" ")}
        >
          <div className={[styles.insetInner, styles.insetLeft, styles[insetPosition]].join(" ")}>
            <Asset asset={props.row.asset[0]} maxWidth="1100" />
          </div>
        </div>
        <div className={`${theme.gmfull} ${styles.half}`}>
          <Asset asset={props.row.asset[1]} maxWidth="1100" />
        </div>
      </div>
    );
  } else {
    return (
      <div
        className={[styles.row, styles[props.type], styles[template], theme.gmcont].join(" ")}
        style={{ backgroundColor: `${props.bgColor}`, color: `${props.textColor}` }}
      >
        <div className={`${theme.gmfull} ${styles.half}`}>
          <Asset asset={props.row.asset[0]} maxWidth="1100" />
        </div>
        <div
          className={[
            theme.gmfull,
            theme.fmcont,
            theme.fmcenter,
            theme.fmvcenter,
            styles.half,
            styles.inset,
          ].join(" ")}
        >
          <div className={[styles.insetInner, styles.insetRight, styles[insetPosition]].join(" ")}>
            <Asset asset={props.row.asset[1]} maxWidth="1100" />
          </div>
        </div>
      </div>
    );
  }
}

export default Row;
